/**
 * NjitCollapse behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};

  Drupal.NjitCollapse = function(trigger) {
      trigger.find('[data-collapsible-toggle]').on('click', function(e) {
        var parent = $(this).parent();
        if(parent.hasClass('open')) {
          parent.removeClass('open');
        } else {
          parent.addClass('open');
        }
        e.preventDefault();
      });
  }

  Drupal.behaviors.NjitCollapse = {
    attach: function (context, settings) {
      $('[data-collapsible]').once('collapse', function() {
        var collapse = new Drupal.NjitCollapse($(this));
      });
    }
  }

})(Drupal, jQuery);
